import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2308145e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2308145e')) {
      api.createRecord('2308145e', component.options)
    } else {
      api.reload('2308145e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2308145e", function () {
      api.rerender('2308145e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/virtualSalesTask/Index.vue"
export default component.exports